import { Redirect, Route } from "react-router-dom";

const PublicRoute = ({ component: Component, isAuthenticated, ...children }) => (
  <Route
    render={
      (props) =>
        isAuthenticated
          ? <Redirect to="/dashboard" />
          : <Component {...props} {...children} />
    }
  />
)

export default PublicRoute;
